module.exports = __webpack_public_path__ + "static/media/360_Tour.1d994cda.png";